import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';

@Injectable({ providedIn: 'root' })
export class StorageProvider {
    isDesktopPlatform: boolean = false;
    isAndroid: boolean = false;
    isIos: boolean = false;

    constructor(
        private platform: Platform,
    ) {
        this.isDesktopPlatform = this.isDesktop();
        this.isAndroid = this.platform.is('android') && !this.isDesktopPlatform;
        this.isIos = this.platform.is('ios') && !this.isDesktopPlatform;
    }

    isDesktop(): boolean {
        if (this.checkLocationIfFromApp()) {
            return false;
        }
        else {
            return this.isDesktopPlatform = this.platform.is("desktop") || this.platform.is('mobileweb');
        }
    }

    checkLocationIfFromApp(): boolean {
        return window.location.href.indexOf("file:") > -1;
    }
}